document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-drawer-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector(button.getAttribute('data-drawer-toggle'));
      if (target) target.toggleAttribute('open');
    });
  });

  document.querySelectorAll('[data-close-drawer]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = button.closest('[open]');
      if (drawer) drawer.removeAttribute('open');
    });
  });
});
